import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService, manageFilters } from '@app/services';
import { IActiveFilter } from '@app/models';

class JitUsersService {
    readonly apiBase = '/api/directory/People';

    getJitUsers(
        orderBy: string,
        asc: string,
        top: number,
        skip: number,
        count: boolean,
        organizationId: string,
        filters?: IActiveFilter[]
    ): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/jitters`, {
                params: {
                    $orderBy: orderBy + ' ' + asc,
                    $top: top,
                    $skip: skip,
                    $count: count,
                    $filter: manageFilters(filters, organizationId)
                },
                local: true
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getImpersonatedOrganizations(): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/ImpersonatedOrganizations`, {
                local: true
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }
    postRevokeMyJitReservation(jitId: string): AxiosPromise {
        return apiService.post(`${this.apiBase}(${jitId})/ExpireReservation`).catch((error: AxiosResponse) => Promise.reject(error));
    }

    getTimeSlot(jitId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}(${jitId})/NextAvailableSlot`, { onError: handleError, onSuccess: handleSuccess }).catch();
    }

    reserveUserSlot(jitId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${jitId})/ReserveImpersonationSlot`, {}, { onError: handleError, onSuccess: handleSuccess }).catch();
    }
}

export const jitUsersService = new JitUsersService();
